import { CrudStoreItemOnboarding } from 'legacy/lut/classes/models/onboarding/CrudStoreItemOnboarding'
import { EFormSource } from 'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestDetail/actionView/dataCollector/FormSelector'

import { CrudStore } from 'core/types/crudStore'
import { IRequestorLA } from 'onboarding/classes/models/requestorLA'
import { TRequestorFill } from 'onboarding/components/widgets/public/forms/models'

class OnboardingRequestorApi {
  public getCrud() {
    return CrudStore.get(CrudStoreItemOnboarding.RequestorFillData)
  }

  public getCrudLA() {
    return CrudStore.get(CrudStoreItemOnboarding.RequestorLAFillData)
  }

  public getByRequestId(requestId: number, force: boolean): Promise<TRequestorFill | null> {
    return this.getCrud().getById({ id: requestId, force, keyField: 'RequestId' })
  }

  public getLAByRequestId(requestId: number, force: boolean): Promise<IRequestorLA | null> {
    return this.getCrudLA().getById({ id: requestId, force, keyField: 'RequestId' })
  }

  public create(data: Partial<TRequestorFill>[]): Promise<TRequestorFill[]> {
    return this.getCrud().create(EFormSource.RequestorToFillApjT1OrEMEAOrApj, data)
  }

  public update(data: Partial<TRequestorFill>[]): Promise<TRequestorFill[]> {
    return this.getCrud().update(EFormSource.RequestorToFillApjT1OrEMEAOrApj, data)
  }

  public createLA(data: Partial<IRequestorLA>[]): Promise<IRequestorLA[]> {
    return this.getCrudLA().create(EFormSource.RequestorToFillLAT1, data)
  }

  public updateLA(data: Partial<IRequestorLA>[]): Promise<IRequestorLA[]> {
    return this.getCrudLA().update(EFormSource.RequestorToFillLAT1, data)
  }
}

export const onboardingRequestorApi = new OnboardingRequestorApi()
